import videojs from 'video.js';
import zhTwJson from 'video.js/dist/lang/zh-TW.json';

videojs.addLanguage('zh-TW', {
  ...zhTwJson,
  'Trad Chinese': '繁體中文',
  'Simp Chinese': '简体中文',
  LIVE: '直播中',
  'This is a modal window.': '這是一個視窗，',
  Auto: '自動',
  qualityLevels: '畫質',
});
